/**
 * useDeleteEltJob Hook
 *
 * React Query mutation hook for deleting an ELT job.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { eltJobService } from '../../../api/elt-job.service';
import { ELT_JOBS_QUERY_KEY } from './useEltJobs';
import { getErrorMessage } from '../../../lib/utils/errors';

interface UseDeleteEltJobOptions {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export function useDeleteEltJob(
  tenantId: string,
  eltJobId: string,
  options?: UseDeleteEltJobOptions
) {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: () => eltJobService.deleteEltJob(tenantId, eltJobId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ELT_JOBS_QUERY_KEY, tenantId] });
      options?.onSuccess?.();
    },
    onError: (error) => {
      options?.onError?.(getErrorMessage(error));
    },
  });
}
